import { render } from "./metod-list.vue?vue&type=template&id=50fa31ae"
import script from "./metod-list.vue?vue&type=script&lang=ts"
export * from "./metod-list.vue?vue&type=script&lang=ts"

import "./metod-list.vue?vue&type=style&index=0&id=50fa31ae&lang=less"
script.render = render

export default script